/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       DetailArrowImage.tsx
 * @author     Christian Ascone
 * @date       10/24/19 3:40 PM
 */

import React from 'react';
import {Image} from "react-native";

export function DetailArrowImage(props) {
    return (
        <Image
            {...props}
            style={[props.style]}
            source={
                require('../../assets/images/detail_arrow.png')
            }
        />
    );
}